import _ from 'underscore';
import { CampaignSelectorView as AdgroupSelectorView } from '@bingads-webui-campaign-react/campaign-selector';
import { getAdgroupData } from './adgroup-selector-repository';

const PAGESIZE = 6;

export class AdgroupSelectorProxy {
  constructor({
    campaignId,
    onEventTrigger,
    getCustomizedData,
    jsData,
    edmCampaign,
    withUiBlocker,
    i18n,
    selectedItem,
    optionalAdgroupFilter,
    campaign,
    optionalAdGroupSelect,
    optionalAdGroupExpand,
    isMultiMode,
    onSelectDone,
  } = {}) {
    this.campaignId = campaignId;
    this.onEventTrigger = onEventTrigger;
    this.getCustomizedData = getCustomizedData || null;
    this.jsData = jsData;
    this.edmCampaign = edmCampaign;
    this.withUiBlocker = withUiBlocker;
    this.i18n = i18n;
    this.selectedItem = selectedItem;
    this.optionalAdgroupFilter = optionalAdgroupFilter;
    this.campaign = campaign;
    this.optionalAdGroupSelect = optionalAdGroupSelect;
    this.optionalAdGroupExpand = optionalAdGroupExpand;
    this.isMultiMode = isMultiMode;
    this.onSelectDone = onSelectDone;
  }

  fecthAdgroupData({
    query,
    pageNumber,
    pageSize,
    adgroupSelectorView,
    optionalAdgroupFilter = this.optionalAdgroupFilter,
  }) {
    const uiBlockContainer = adgroupSelectorView && adgroupSelectorView.$el && adgroupSelectorView.$el.find('.dropdown-menu');

    if (this.getCustomizedData === null) {
      return getAdgroupData({
        query,
        pageNumber,
        pageSize,
        campaignId: this.campaignId,
        optionalAdgroupFilter,
        optionalAdGroupSelect: this.optionalAdGroupSelect,
        optionalAdGroupExpand: this.optionalAdGroupExpand,
      }, this.jsData, this.edmCampaign).finally(this.withUiBlocker(uiBlockContainer));
    }

    return this.getCustomizedData({
      query,
      pageNumber,
      pageSize,
      campaignId: this.campaignId,
    }, this.jsData, this.edmCampaign).finally(this.withUiBlocker(uiBlockContainer));
  }

  getAdgroupSelectorView() {
    const checkSelected = (selectedItem, item) => selectedItem && selectedItem.Id === item.Id;
    const adgroupSelectorView = new AdgroupSelectorView({
      i18n: this.i18n,
      fetch: ({ query = '', pageNumber = 0 }) => this.fecthAdgroupData({
        query,
        pageNumber,
        pageSize: PAGESIZE,
        adgroupSelectorView,
      }),
      pageSize: PAGESIZE,
      stringKeys: {
        emptyListContent: _TL_('No results to display.'),
        listHeader: _TL_('Available ad groups: {{itemCount}}'),
        selectEntity: _TL_('Select an ad group'),
        resultHeader: _TL_('Selected ad groups: {{itemCount}}'),
        selectEntities: _TL_('Select ad group(s)'),
        actionBar: _TL_('Select all on this page'),

      },
      selectedItem: this.selectedItem,
      checkSelected,
      campaign: this.campaign,
      isMultiMode: this.isMultiMode,
      onSelectDone: this.onSelectDone,
    });

    adgroupSelectorView.on('selected-campaign', (selectedItem) => {
      if (_.isFunction(this.onEventTrigger)) {
        this.onEventTrigger(selectedItem);
      }
    });

    return adgroupSelectorView;
  }
}
